import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Container } from 'reactstrap'
import { H2, H4, LI, UL } from "../../../AbstractElements";
import { APP_PATHS } from "../../../utils/appPaths";

const Maintenance = () => {
    return (
        <Fragment>
            <section className="maintenance-sec">
                <div className="page-wrapper">
                    <div className="error-wrapper maintenance-bg">
                        <Container>
                            <UL attrUL={{ className: "maintenance-icons flex-row" }} >
                                <LI><i className="fa fa-cog"></i></LI>
                                <LI><i className="fa fa-cog"></i></LI>
                                <LI><i className="fa fa-cog"></i></LI>
                            </UL>
                            <div className="maintenance-heading">
                                <H2 attrH2={{ className: "headline" }} >MAINTENANCE</H2>
                            </div>
                            <H4 attrH4={{ className: "sub-content" }} >Our Site is Currently under maintenance We will be back Shortly<br />Thank You For Patience</H4>
                            <div><Link className="btn btn-primary btn-lg text-light" to={APP_PATHS.dashboard}>BACK TO HOME PAGE</Link></div>
                        </Container>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default Maintenance;